import React from "react";
import { Routes, Route } from "react-router-dom";

import { TransferMoney } from "../pages/TransferMoney";
import { BankList } from "../pages/BankList";
import { WithdrawHistory } from "../pages/WithdrawHistory";

// Rozar Pays

import { NotFound } from "../pages/NotFound";
import { Emandate } from "../pages/Emandate";
import { EnterBankDetails } from "../pages/EnterBankDetails";
import { EnterName } from "../pages/EnterName";
import { EnterPan } from "../pages/EnterPan";
import { Home } from "../pages/Home";
import { PanVerification } from "../pages/PanVerification";
import RozarPayPayment from "../pages/RozarPay/RozarPayPayment";
import RozarPayPaymentStatus from "../pages/RozarPay/RozarPayPaymentStatus";

export default function AppRoute() {
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="/bank-list" element={<BankList />} />
      <Route path="/emandate" element={<Emandate />} />
      <Route path="/enter-bank-details" element={<EnterBankDetails />} />
      <Route path="/enter-name" element={<EnterName />} />
      <Route path="/enter-pan" element={<EnterPan />} />
      <Route path="/" element={<Home />} />
      <Route path="/pan-verification" element={<PanVerification />} />
      <Route path="/transfer-money" element={<TransferMoney />} />
      <Route path="/withdraw-history" element={<WithdrawHistory />} />

      <Route path="/rozarpay-payment" element={<RozarPayPayment />} />
      <Route path="/rozarpay-payment-status" element={<RozarPayPaymentStatus />} />
    </Routes>
  );
}
